import React, { useState, useEffect } from 'react';
import { createBrowserHistory } from 'history';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { useSelector } from 'react-redux';
import { RootState } from 'store/ducks';

import { useLocation } from 'react-router-dom';
import { platforms, urlsAutomacao } from './eventNames';

const browserHistory = createBrowserHistory();

export const reactPlugin = new ReactPlugin();

const _appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: process.env.REACT_APP_APP_INSIGHTS_INSTRUMENTATION_KEY,
    extensions: [reactPlugin],
    extensionConfig: {
      [reactPlugin.identifier]: { history: browserHistory },
    },
  },
});

_appInsights.loadAppInsights();

export const appInsights = _appInsights;

export function useCustomEvent(
  component: string,
  action: string,
  eventData?: any
) {
  const location = useLocation();
  const user = useSelector((state: RootState) => state.user);
  const tracking = useSelector((state: RootState) => state.tracking);
  const urlsExists = urlsAutomacao.includes(location.pathname.split('/')[1]);

  const [data, setData] = useState(eventData);
  useEffect(() => {
    if (data) {
      reactPlugin.trackEvent(
        {
          name: action,
        },
        {
          ...data,
          perfil: user?.userType ? user.userType : 'indefinido',
          page: tracking?.pageTitle?.toUpperCase(),
          component: component?.toUpperCase(),
          action: action?.toUpperCase(),
          plataforma: urlsExists ? platforms.AUTOMACAO : platforms.CCARE,
          ...data,
        }
      );
      setData(undefined);
    }
  }, [data]);

  return setData;
}
export function usePrevious(value: any) {
  const ref = React.useRef();
  useEffect(() => {
    ref.current = value;
  });

  return ref.current;
}

export function useLocationChange(
  // eslint-disable-next-line no-unused-vars
  action: (currentLocation: any, previousLocation: any) => void
) {
  const history = useLocation();
  const prevLocation = usePrevious(history);

  useEffect(() => {
    action(history, prevLocation);
  }, [history]);
}
